import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { InternalCurrency, OpenInternalCurrencyDialog } from "./dialogs/internalCurrencyDialog";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditInternalCurrencies extends React.Component<EditInternalCurrencyProps, EditInternalCurrencyState> {
    private _gridOptions: any;
    private _translations: string[] = null;

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            enableDeleteButton: false,
            selectedItem: null
        };
    }

    private _save = () => {
        let url = "Currency/SaveInternal";
        HTTPService.post<JsonResultClass>(url, { model: this.state.selectedItem })
            .then(result => {
                if (result.Code == 0) {
                    this._getGridData();
                } else {

                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _delete = () => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "Currency/DeleteInternal";
                HTTPService.post<JsonResultClass>(url, { model: this.state.selectedItem })
                    .then(result => {
                        if (result.Code == 0) {
                            this._getGridData();
                        } else {

                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    private _getGridData = () => {
        let url = "Currency/GetAllInternal";
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _createGrid = () => {

        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this._gridOptions) && Helper.hasValue(this._translations);

        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });
            let grid = (
                <Grid data={this.state.gridData} options={this._gridOptions} id="internalCurrenciesGrid" onSelectionChanged={this._onSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} onDataBound={this.handleDataBound} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    handleDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsCurrent) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td", row);
                cell.css("background-color", "var( --primary-color)");
                cell.css("color", "white");
            }
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: InternalCurrency) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this.onEditInternalCurrency(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this.onCreateNewInternalCurrency();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._delete();
        }
    }

    private onEditInternalCurrency = async (sourceCurrency: InternalCurrency) => {
        let currency = await OpenInternalCurrencyDialog(sourceCurrency);
        sourceCurrency.Currency = currency.Currency;
        sourceCurrency.From = currency.From;
        sourceCurrency.To = currency.To;
        this.setState({ selectedItem: sourceCurrency }, () => this._save());
    }

    private onCreateNewInternalCurrency = async () => {
        let currency = await OpenInternalCurrencyDialog();
        currency.IsNew = true;
        this.setState({ selectedItem: currency }, () => this._save());
    }

    private _onSelectedChange = (dataItem: InternalCurrency) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeletable, selectedItem: dataItem });
        }
    }

    componentDidMount() {
        this._gridOptions = this.props.context.internalCurrencyGridOptions;
        this._translations = this.props.context.translations;
        this._getGridData();
    }

    render() {

        const grid = this._createGrid();
        return (
            <>
                {grid}
            </>);
    }
};

interface EditInternalCurrencyProps {
    context: ContextGeneralSettingsApp;
}

interface EditInternalCurrencyState {
    enableDeleteButton: boolean;
    selectedItem: InternalCurrency;
    gridData: InternalCurrency[];
}
